var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('maintenance'),_c('h1',[_vm._v(_vm._s(_vm.gt("under_construction")))]),_c('h3',[_vm._v(_vm._s(_vm.gt("wewillbeback")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }